<template>
  <v-card class="pa-2 shadow half-radius" color="#e0f6ff">
    <app-remove-button
      @click="$emit('delete')"
      class="absolute"
      style="right: 16px"
    />
    <span class="font-weight-semibold">
      Word Here
      <v-icon size="20" class="mb-1" color="black">mdi-arrow-down</v-icon>
    </span>
    <app-editor ref="content" @input="$emit('update:content', $event)" />
    <v-card-actions>
      <app-record-button :recording="recording" small @click="onRecord" />
      <app-remove-button
        v-if="!recording && audioUrl"
        @click="removeSelectedAudio"
      />
      <v-spacer />
      <app-button-player v-if="value" :src="computedSrc" :player="false" />
    </v-card-actions>
  </v-card>
</template>
<script>
import audioMixin from "@/mixins/audioMixin";
import Editor from "@/components/Utils/Editor.vue";
import RecordButton from "@/components/Lessons/Lesson/components/RecordButton.vue";
import RemoveButton from "@/components/Lessons/Lesson/components/RemoveButton.vue";
import ButtonPlayer from "@/components/Lessons/Lesson/components/ButtonPlayer.vue";

export default {
  components: {
    appEditor: Editor,
    appRecordButton: RecordButton,
    appRemoveButton: RemoveButton,
    appButtonPlayer: ButtonPlayer,
  },
  props: {
    value: [String, Object, Blob],
    content: Object,
  },
  mixins: [audioMixin],
  computed: {
    computedSrc() {
      if (typeof this.value === "string") {
        return this.value;
      } else if (typeof this.value === "object") {
        try {
          return URL.createObjectURL(this.value);
        } catch (error) {
          return "";
        }
      }
      return "";
    },
  },
  methods: {
    removeSelectedAudio() {
      this.$emit("input", null);
      this.audioUrl = null;
      this.audioBlob = null;
      this.timeStamp = 0;
    },
  },
  mounted() {
    if (this.content) {
      if (typeof this.content === "string") {
        try {
          this.$refs.content.setContent(JSON.parse(this.content));
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log(error);
        }
      } else if (typeof this.content === "object") {
        this.$refs.content.setContent(this.content);
      }
    }
    this.$on("stop-recording", () => {
      this.$emit("input", this.audioBlob);
    });
  },
};
</script>
